import React, {useContext} from "react";
import { PullRequestOutlined, RightOutlined } from "@ant-design/icons";
import {Layout} from "antd";
import {Link, Outlet, useLocation} from "react-router-dom";
import '../../../styles/component/asset/asset-allocation-request.scss';
import UserLoginContext from "../../../context/userLoginContext";



function AssetAllocationAndRequest() {
    const location = useLocation();
    const {user} = useContext(UserLoginContext);

    const assetSidebarItems = [
        {
            key: 1,
            label: "Asset Allocation",
            route: "asset/allocation",
            leftIcon: <PullRequestOutlined className="left-icon"/>,
            rightIcon: <RightOutlined className="right-icon"/>,
            className: "asset-allocation"
        },
        {
            key: 2,
            label: "Asset Request",
            route: "asset/request",
            leftIcon: <PullRequestOutlined className="left-icon"/>,
            rightIcon: <RightOutlined className="right-icon"/>,
            className: "asset-request"
        },
        ...(user?.isAdmin
            ? [{
                key: 3,
                label: "Overdue Assets",
                route: "asset/overdue",
                leftIcon: <PullRequestOutlined className="left-icon"/>,
                rightIcon: <RightOutlined className="right-icon"/>,
                className: "overdue-asset"
            }]
            : [])
    ];

    // Used for highlighting active tab
    const checkIfTabActive = (tabRoute: string) =>
        location.pathname.includes(tabRoute);

    const Sidebar = () => (
        <ul className={'sidebar-item-list'}>
            {assetSidebarItems.map((item) => (
                <li
                    key={item.key}
                    className={`asset-management sidebar-item  ${item.className} ${
                        checkIfTabActive(item.route) ? "active" : ""
                    }`}
                >
                    <Link to={item.route}>
                        {item.leftIcon}
                        {item.label}
                        {item.rightIcon}
                    </Link>
                </li>
            ))}
        </ul>
    );

    return (
        <Layout className="asset-management asset-page-layout ">
            <header className={"asset-management asset-page-layout__heading"}>
                <h3 className="title">Asset Request and Allocation</h3>
            </header>

            <div className="asset-management asset-page-layout__content">
                <div className="asset-management asset-page-layout__sidebar">
                    <Sidebar/>
                </div>

                <div className="asset-management asset-page-layout__table">
                    <Outlet/>
                </div>
            </div>
        </Layout>
    )
}

export default AssetAllocationAndRequest;
